import Vue from "vue";
import phParams from "./ph-params.json";
const vm = new Vue();

// listar investimentos
export const getInvestments = () =>
  new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_INVESTMENTS}/${Number(sessionStorage.aid)}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

// lista de configurações de parâmetros
export const getParameterSettings = (investmentId) =>
  new Promise((resolve, reject) =>
    vm.$api
      .get(`${vm.$endpoint.LIST_PARAMS}/${investmentId}`)
      .then((res) => (res.status == 200 ? resolve(res.data) : reject()))
  );

// iniciar robô
export const startBot = (params) =>
  new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.START_INVESTMENT}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.data));
  });

export const startBotPortfolio = (params) =>
  new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.START_INVESTMENT_PORTFOLIO}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.data));
  });
// parar robô
export const stopBot = (params) =>
  new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.STOP_INVESTMENT}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.data));
  });

export const stopBotPortfolio = (params) =>
  new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.STOP_INVESTMENT_PORTFOLIO}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.data));
  });
export const stopAll = (params) =>
  new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.STOP_ALL_INVESTMENTS}`, params)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });

// ---------------------------------------------------------------

export const listParams = (investmentId) =>
  new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.LIST_PARAMS}/${investmentId}`)
      .then((res) => (res.status == 200 ? resolve(res.data) : reject()));
  });

export const getParamInfo = (investment_id, param_id) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_PARAM_INFO}/${investment_id}/${param_id}`)
      .then((res) => {
        // if (res.data.param_id === 84) {
        //   resolve({ ...res.data, param_params: phParams })
        // }
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
};

export const resetParam = (body) => {
  return new Promise((resolve, reject) => {
    vm.$api.post(vm.$endpoint.PARAM_RESET, body).then((res) => {
      res.status == 200 ? resolve(res.data) : reject();
    });
  });
};

export const deleteParam = (body) => {
  return new Promise((resolve, reject) => {
    vm.$api.post(vm.$endpoint.PARAM_DELETE, body).then((res) => {
      res.status == 200 ? resolve(res.data) : reject();
    });
  });
};

export const createParam = (body) =>
  new Promise((resolve, reject) =>
    vm.$api
      .post(vm.$endpoint.CREATE_PARAM, body)
      .then((res) => (res.status == 200 ? resolve(res.data) : reject()))
      .catch((err) => reject(err.data))
  );

export const updateParam = (body) => {
  return new Promise((resolve, reject) => {
    vm.$api.post(vm.$endpoint.UPDATE_PARAMS, body).then((res) => {
      res.status == 200 ? resolve(res.data) : reject();
    });
  });
};
